<script>
import { Bar } from 'vue-chartjs';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  data: function() {
    return {
      numberGenerated: [],
      verboseDays: []
    };
  },
  extends: Bar,
  props: ['height'],
  created() {
    this.fetchRecentlyCompleted().then(r => {
      const obj = Object.assign([], this.getRecentlyCompleted);
      // for (const inc in obj) {
      //   console.log(obj[inc]);
      // }

      const days = [...Array(18).keys()];
      const numberGenerated = [];
      days.shift();
      days.reverse();
      const verboseDays = [];
      // const verboseDays = [];
      for (const i in days) {
        verboseDays.push(
          moment()
            .subtract(days[i], 'd')
            .format('dddd, [the] Do [of] MMM')
        );
        const dateToCheck = moment()
          .subtract(days[i], 'd')
          .format('M-D-YYYY');
        let c = 0;
        for (const inc in obj) {
          if (dateToCheck === obj[inc].completion_date) {
            c++;
          }
        }
        numberGenerated[i] = c;
      }
      this.numberGenerated = numberGenerated;

      const datasets4 = [
        {
          label: 'Reports Generated',
          backgroundColor: 'rgba(255,255,255,.3)',
          borderColor: 'transparent',
          data: this.numberGenerated // [78, 81, 80, 45, 34, 12, 40, 75, 34, 89, 32, 68, 54, 72, 18, 98]
        }
      ];
      this.renderChart(
        {
          labels: verboseDays,
          datasets: datasets4
        },
        {
          tooltips: {
            enabled: false,
            custom: CustomTooltips
          },
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                display: false,
                categoryPercentage: 1,
                barPercentage: 0.5
              }
            ],
            yAxes: [
              {
                display: false
              }
            ]
          }
        }
      );
    });
  },
  computed: {
    ...mapGetters('dashboard', ['getTestTakersOnline', 'getRecentlyCompleted'])
  },
  methods: {
    ...mapActions('dashboard', ['fetchActiveUsers', 'fetchRecentlyCompleted'])
  }
};
</script>
